import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["textContent"]

interface Props {
  message: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'FieldError',
  props: {
    message: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "text-red-500 text-sm mt-1 mb-4",
    "data-testid": "errorMessage",
    textContent: _toDisplayString(props.message)
  }, null, 8 /* PROPS */, _hoisted_1))
}
}

})